import { md5 } from '@roai/shared';
interface IWebGLInfo {
  VENDOR: string;
  RENDERER: string;
  VERSION: string;
  SHADING_LANGUAGE_VERSION: string;
  MAX_TEXTURE_SIZE: string;
  MAX_VIEWPORT_DIMS: string;
  MAX_RENDERBUFFER_SIZE: string;
  MAX_TEXTURE_IMAGE_UNITS: string;
  MAX_VERTEX_TEXTURE_IMAGE_UNITS: string;
  MAX_COMBINED_TEXTURE_IMAGE_UNITS: string;
  MAX_VERTEX_ATTRIBS: string;
  MAX_VARYING_VECTORS: string;
  MAX_VERTEX_UNIFORM_VECTORS: string;
  MAX_FRAGMENT_UNIFORM_VECTORS: string;
}

export function getWebGLInfo(): Nullable<IWebGLInfo> {
  const canvas = document.createElement('canvas');

  try {
    const gl = (canvas.getContext('webgl') ||  canvas.getContext('experimental-webgl')) as WebGLRenderingContext;
    if (!gl) {
      return null;
    }

    return {
      VENDOR: gl.getParameter(gl.VENDOR),
      RENDERER: gl.getParameter(gl.RENDERER),
      VERSION: gl.getParameter(gl.VERSION),
      SHADING_LANGUAGE_VERSION: gl.getParameter(gl.SHADING_LANGUAGE_VERSION),
      MAX_TEXTURE_SIZE: gl.getParameter(gl.MAX_TEXTURE_SIZE),
      MAX_VIEWPORT_DIMS: gl.getParameter(gl.MAX_VIEWPORT_DIMS),
      MAX_RENDERBUFFER_SIZE: gl.getParameter(gl.MAX_RENDERBUFFER_SIZE),
      MAX_TEXTURE_IMAGE_UNITS: gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS),
      MAX_VERTEX_TEXTURE_IMAGE_UNITS: gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
      MAX_COMBINED_TEXTURE_IMAGE_UNITS: gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
      MAX_VERTEX_ATTRIBS: gl.getParameter(gl.MAX_VERTEX_ATTRIBS),
      MAX_VARYING_VECTORS: gl.getParameter(gl.MAX_VARYING_VECTORS),
      MAX_VERTEX_UNIFORM_VECTORS: gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS),
      MAX_FRAGMENT_UNIFORM_VECTORS: gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS),
    }
  } catch (e) {
    return null;
  }
}


export function getWebGLFingerprint(): string {
  try {
    const webGLInfo = JSON.stringify(getWebGLInfo());
    return md5(webGLInfo).toString(); 
  } catch (e) {
    return '';
  }
}
